import React, { Component } from 'react'
import { Link } from 'gatsby'

const sliders = [
  {
    title: {
      zh: '大灣區專業培訓中心',
      en: 'The Greater Bay Area Cooperation'
    },
    url: '/images/sliders/slider-01.jpg',
    link: '/league-of-elite#highlights'
  },
  {
    title: {
      zh: '學生研究',
      en: 'Research'
    },
    url: '/images/sliders/slider-02.jpg',
    link: '/research'
  },
  {
    title: {
      zh: '綠色健康校園',
      en: 'Green and Healthy Campus'
    },
    url: '/images/sliders/slider-03.jpg',
    link: '/campus#green-and-healthy-campus'
  },
]

class Sliders extends Component {
  render() {
    return (
      <div className="relative sliders">
        <div className="absolute inset-0">
          <div className="carousel">
            {
              sliders.map((slider, i) => (
                <Link key={i} to={`${this.props.lang === 'zh' ? '/zh' : '/'}${slider.link}`} className="block carousel-cell" style={ {backgroundImage: `url('/AnnualReport2017-2018${slider.url}')`} }></Link>
              ))
            }
          </div>

          <div className="relative container text-white">
            <div className="absolute inset-x-0 w-full -mt-16 hidden md:flex flex-row px-4">
              {
                sliders.map((slider, i) => (
                  <button type="button"
                    key={i}
                    data-index={i}
                    className={`slider-title h-16 flex-auto flex items-center focus:outline-none border-b-12 overflow-hidden`}
                  >
                    { slider.title[this.props.lang] }
                  </button>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Sliders
